import { cn } from "../../lib/utils";
import { Mic, MicOff, Square } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { useVoiceInput } from "../../hooks/useVoiceInput";
import { useEffect } from "react";

export function VoiceInput({ value, onChange, placeholder, className }) {
  const {
    isRecording,
    transcript,
    isSupported,
    toggleRecording,
    setTranscript,
  } = useVoiceInput();

  // Sync transcript to value when recording stops
  useEffect(() => {
    if (!isRecording && transcript) {
      onChange(value ? `${value} ${transcript}`.trim() : transcript.trim());
      setTranscript("");
    }
  }, [isRecording, transcript, onChange, setTranscript, value]);

  return (
    <div className={cn("relative", className)}>
      <Textarea
        value={isRecording ? `${value || ""} ${transcript}`.trim() : value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="min-h-[100px] pr-14 resize-none"
        disabled={isRecording}
        data-testid="voice-input-textarea"
      />
      
      {isSupported && (
        <Button
          type="button"
          variant={isRecording ? "destructive" : "outline"}
          size="icon"
          className={cn(
            "absolute bottom-3 right-3 rounded-full transition-all",
            isRecording && "recording-pulse"
          )}
          onClick={toggleRecording}
          data-testid="voice-record-button"
        >
          {isRecording ? (
            <Square className="h-4 w-4" />
          ) : (
            <Mic className="h-4 w-4" />
          )}
        </Button>
      )}
      
      {isRecording && (
        <div className="absolute bottom-3 left-3 flex items-center gap-1" data-testid="voice-waveform">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="waveform-bar w-1 bg-destructive rounded-full"
              style={{ height: "8px" }}
            />
          ))}
        </div>
      )}
      
      {!isSupported && (
        <div className="absolute bottom-3 right-3">
          <MicOff className="h-4 w-4 text-muted-foreground" />
        </div>
      )}
    </div>
  );
}
